import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CapturumSharedModule } from '@capturum/ui/api';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { startWith } from 'rxjs';

@Component({
  selector: 'app-formly-radio-type',
  imports: [
    FormsModule,
    FormlyModule,
    ReactiveFormsModule,
    RadioButtonModule,
    CapturumSharedModule,
    AsyncPipe,
    TooltipModule,
  ],
  templateUrl: './formly-radio-type.component.html',
  styleUrl: './formly-radio-type.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyRadioTypeComponent extends FieldType implements OnInit {
  public radioForm: FormGroup = new FormGroup({
    radio: new FormControl(null),
  });

  private destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.formControl.valueChanges
      .pipe(startWith(this.formControl.value), takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        this.radioForm.get('radio').setValue(value, { emitEvent: false });
      });

    this.radioForm
      .get('radio')
      .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        this.formControl.setValue(value, { emitEvent: false });
        this.formControl.updateValueAndValidity();
      });
  }
}
